import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import style from "css/template.module.css";
import { useMediaQuery } from "react-responsive";
import MobileMenuItem from "./mobile/mobileMenuItem";
import MobileSmartSpace from "./mobile/mobileSmartSpace";
import MobileSmartDevice from "./mobile/mobileSmartDevice";
import MobileSmartSolution from "./mobile/mobileSmartSolution";
import LanguageSelect from "component/common/LanguageSelect";

/**
 * Version : 1.0
 * 작성일자 : 2023-12-11
 * 작성자 : 권도훈
 * 설명 : 공통 템플릿 영역
 */
function Header(props) {
  const { t, i18n } = useTranslation();
  const phoneDisplay = String(i18n.language).toLowerCase().startsWith("en")
    ? "+82-70-7798-1311"
    : "070 - 7798 - 1311";
  const { pathname } = useLocation();
  const navigate = useNavigate();
  //payload
  const payload = useSelector((state) => state.scroll);

  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const [openMenuType, setOpenMenuType] = useState("");

  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [menuType, setMenuType] = useState("");

  //PC 상단 헤더 클릭 이벤트
  const handleMenuClick = (type) => {
    props.handleNavLink(type);
  };

  //모바일 메뉴 버튼 클릭 이벤트
  const handleMobileMenuOpen = () => {
    if (isOpenMenu) {
      setIsOpenMenu(false);
    } else {
      setIsOpenMenu(true);
    }
  };

  const handleDownloadIntroduction = () => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_CLIENT_URL}docs/Introduction_riv_technology.pdf`;
    link.download = t("header.downloadPdfName");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (isOpenMenu) {
      // setMenuType("");
      setIsOpenMenu(false);
    }
  }, [pathname]);

  if (pathname.startsWith("/signup")) return null;

  return (
    <>
      <div
        id="page_header"
        className={style.header}
      >
        {props.isOpenNotice ? (
          <div className={style.header_notice_wrap}>
            <div className={style.header_notice_text}>
              {t("header.noticeLine1")}
              {"\n"}
              {t("header.noticeLine2")}{" "}
              <span onClick={() => handleMenuClick("saas")}>
                {t("header.noticeSaaS")}
              </span>
              {` ${t("header.noticeAnd")} `}
              <span onClick={() => handleMenuClick("on-premise")}>
                {t("header.noticeOnPrem")}
              </span>
              {t("header.noticeLine3")}
            </div>
            <img
              onClick={() => props.setIsOpenNotice(false)}
              src={
                `${process.env.REACT_APP_CLIENT_URL}` + "img/header/close.png"
              }
              alt="close"
            />
          </div>
        ) : null}

        {!isMobile && !isTablet ? (
          <div className={style.header_wrap}>
            <div className={style.header_container}>
              <div onClick={props.scrollToTop}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/header/logo.png"
                  }
                  alt="logo"
                />
              </div>

              <div className={style.header_menu_wrap}>
                <div
                  className={
                    "space" === menuType && isOpenMenu
                      ? `${style.header_menu_btn} ${style.active}`
                      : `${style.header_menu_btn}`
                  }
                  onClick={() => handleMenuClick("allplace")}
                >
                  <span>{t("header.navAllplace")}</span>
                </div>

                <div
                  className={
                    "device" === menuType && isOpenMenu
                      ? `${style.header_menu_btn} ${style.active}`
                      : `${style.header_menu_btn}`
                  }
                  onClick={() => handleMenuClick("feature")}
                >
                  <span>{t("header.navFeature")}</span>
                </div>
                <div
                  className={
                    "solution" === menuType && isOpenMenu
                      ? `${style.header_menu_btn} ${style.active}`
                      : `${style.header_menu_btn}`
                  }
                  onClick={() => handleMenuClick("saas")}
                >
                  <span>{t("header.navPricing")}</span>
                </div>
              </div>

              <div className={style.header_actions}>
                <LanguageSelect className={style.header_lang_select} />
                {/* 임시 로그인 버튼 */}
                <button
                  className={style.header_nav_btn}
                  onClick={() => {
                    window.location.href = `${window.location.origin}/service/`;
                  }}
                >
                  {t("header.login")}
                </button>
                {/* 임시 체험하기 버튼 */}
                <button
                  className={style.header_nav_btn}
                  onClick={() => navigate("/signup")}
                >
                  {t("header.trial")}
                </button>
                <button
                  className={style.header_nav_btn}
                  onClick={() => handleMenuClick("contact")}
                >
                  {t("header.contact")}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className={style.header_wrap}>
            <div className={style.header_container}>
              <div onClick={props.scrollToTop}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/header/logo.png"
                  }
                  alt="logo"
                  style={{ width: "81px" }}
                />
              </div>
              <div className={style.header_mobile_actions}>
                <LanguageSelect
                  className={style.header_lang_select_mobile}
                  variant="compact"
                />
                <button
                  className={style.header_btn}
                  onClick={() => handleMobileMenuOpen()}
                >
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/menu.png`}
                    alt="menu"
                  />
                </button>
              </div>
              <div
                className={
                  isOpenMenu
                    ? `${style.mobile_menu_wrap} ${style.on}`
                    : `${style.mobile_menu_wrap}`
                }
              >
                <div
                  className={style.mobile_menu_outer}
                  onClick={() => handleMobileMenuOpen()}
                >
                  <div
                    className={style.mobile_menu_container}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className={style.mobile_menu_header_content}>
                      <button
                        className={style.close_menu_btn}
                        onClick={() => handleMobileMenuOpen()}
                      >
                        <img
                          src={`${process.env.REACT_APP_CLIENT_URL}img/common/close.webp`}
                          alt="menu"
                        />
                      </button>
                    </div>
                    {/* body */}
                    <section className={style.menu_body_content}>
                      <ul className={style.menu_list}>
                        <li
                          className={style.menu_item}
                          onClick={() => {
                            handleMobileMenuOpen();
                            handleMenuClick("allplace");
                          }}
                        >
                          <div className={style.menu_info}>
                            <p>{t("header.navAllplace")}</p>
                          </div>
                        </li>
                        <li
                          className={style.menu_item}
                          onClick={() => {
                            handleMobileMenuOpen();
                            handleMenuClick("feature");
                          }}
                        >
                          <div className={style.menu_info}>
                            <p>{t("header.navFeature")}</p>
                          </div>
                        </li>
                        <li
                          className={style.menu_item}
                          onClick={() => {
                            handleMobileMenuOpen();
                            handleMenuClick("saas");
                          }}
                        >
                          <div className={style.menu_info}>
                            <p>{t("header.navPricing")}</p>
                          </div>
                        </li>
                      </ul>
                    </section>
                    {/* footer */}
                    <section className={style.menu_footer_content}>
                      {/* <button
                        className={style.company_intro_btn}
                        onClick={handleDownloadIntroduction}
                      >
                        <img
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/icon_riv.png`}
                          alt=""
                        />
                        <p>{t("header.downloadIntro")}</p>
                        <img
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/download.png`}
                          alt=""
                        />
                      </button> */}
                      <div className={style.footer_company_info}>
                        <div className={style.footer_company_info_title}>
                          <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/call.png`}
                            alt=""
                          />
                          <p>{t("header.mobileConsultTitle")}</p>
                        </div>
                        <ul className={style.footer_company_info_list}>
                          <li className={style.footer_company_info_item}>
                            <p>Tel.</p>
                            <a href="tel:+827077981311">{phoneDisplay}</a>
                          </li>
                          <li className={style.footer_company_info_item}>
                            <p>E-mail.</p>
                            <p>support@riv-tech.co.kr</p>
                          </li>
                        </ul>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Header;
